import React from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  VStack,
  HStack,
  Icon,
  Badge,
  useColorModeValue,
} from "@chakra-ui/react";

import { FaRocket, FaClock, FaBell, FaArrowLeft } from "react-icons/fa";

import { useNavigate } from "react-router-dom";

const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <Flex
      minH="100vh"
      width="100%"
      align="center"
      justify="center"
      position="relative"
      overflow="hidden"
      bg="#F7FAF8"
      px={4}
    >
      {/* Background decorative circles */}
      <Box
        position="absolute"
        width="400px"
        height="400px"
        borderRadius="full"
        bg="#0F3D2E"
        opacity="0.06"
        top="-120px"
        left="-120px"
      />

      <Box
        position="absolute"
        width="350px"
        height="350px"
        borderRadius="full"
        bg="#F7941D"
        opacity="0.08"
        bottom="-120px"
        right="-100px"
      />

      {/* Small decorative circles */}
      <Box
        position="absolute"
        width="20px"
        height="20px"
        borderRadius="full"
        bg="#F7941D"
        top="18%"
        left="15%"
        opacity="0.8"
      />

      <Box
        position="absolute"
        width="14px"
        height="14px"
        borderRadius="full"
        bg="#0F3D2E"
        bottom="20%"
        right="18%"
        opacity="0.7"
      />

      {/* Main Card */}
      <Box
        width="100%"
        maxW="850px"
        bg="white"
        borderRadius="3xl"
        boxShadow="0 25px 70px rgba(15, 61, 46, 0.15)"
        border="1px solid"
        borderColor="gray.100"
        p={{ base: 8, md: 14 }}
        position="relative"
        zIndex={2}
        textAlign="center"
      >
        {/* Logo / Icon */}
        <Flex
          mx="auto"
          width={{ base: "75px", md: "95px" }}
          height={{ base: "75px", md: "95px" }}
          borderRadius="full"
          bg="#0F3D2E"
          align="center"
          justify="center"
          boxShadow="0 12px 30px rgba(15, 61, 46, 0.25)"
          position="relative"
        >
          <Icon as={FaRocket} color="#F7941D" boxSize={{ base: 8, md: 10 }} />

          {/* Notification dot */}
          <Box
            position="absolute"
            top="3px"
            right="5px"
            width="18px"
            height="18px"
            borderRadius="full"
            bg="#F7941D"
            border="3px solid white"
          />
        </Flex>

        {/* Badge */}
        <Badge
          mt={7}
          px={4}
          py={2}
          borderRadius="full"
          bg="#FFF3E6"
          color="#D66B00"
          fontSize="xs"
          fontWeight="800"
          letterSpacing="1px"
        >
          🚀 FEATURE COMING SOON
        </Badge>

        {/* Heading */}
        <Text
          mt={5}
          fontSize={{ base: "3xl", md: "5xl" }}
          fontWeight="900"
          color="#0F3D2E"
          lineHeight="1.1"
        >
          Something Amazing
          <Box as="span" color="#F7941D">
            {" "}
            Is Coming!
          </Box>
        </Text>

        {/* Description */}
        <Text
          mt={5}
          maxW="650px"
          mx="auto"
          color="gray.600"
          fontSize={{ base: "md", md: "lg" }}
          lineHeight="1.8"
        >
          We're working hard to bring you a powerful new feature that will make
          managing your Off Shop even easier, faster, and smarter.
        </Text>

        {/* Feature highlights */}
        <HStack
          mt={9}
          spacing={{ base: 3, md: 6 }}
          justify="center"
          flexWrap="wrap"
        >
          <Flex
            align="center"
            gap={2}
            px={4}
            py={3}
            bg="#F7FAF8"
            borderRadius="xl"
          >
            <Icon as={FaClock} color="#0F3D2E" />
            <Text fontSize="sm" fontWeight="700" color="#0F3D2E">
              Coming Soon
            </Text>
          </Flex>

          <Flex
            align="center"
            gap={2}
            px={4}
            py={3}
            bg="#FFF8F0"
            borderRadius="xl"
          >
            <Icon as={FaBell} color="#F7941D" />
            <Text fontSize="sm" fontWeight="700" color="#D66B00">
              Stay Tuned
            </Text>
          </Flex>
        </HStack>

        {/* Divider */}
        <Box
          width="100%"
          maxW="450px"
          mx="auto"
          height="1px"
          bg="gray.100"
          my={9}
        />

        {/* Buttons */}
        <HStack justify="center" spacing={4} flexWrap="wrap">
          <Button
            leftIcon={<FaArrowLeft />}
            bg="#0F3D2E"
            color="white"
            size="lg"
            px={7}
            borderRadius="xl"
            _hover={{
              bg: "#0B2F24",
              transform: "translateY(-2px)",
              boxShadow: "0 10px 25px rgba(15, 61, 46, 0.25)",
            }}
            _active={{
              transform: "scale(0.97)",
            }}
            transition="all 0.2s"
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>

          <Button
            variant="outline"
            borderColor="#F7941D"
            color="#D66B00"
            size="lg"
            px={7}
            borderRadius="xl"
            _hover={{
              bg: "#FFF3E6",
              transform: "translateY(-2px)",
            }}
            transition="all 0.2s"
            onClick={() => navigate("/")}
          >
            Go to Dashboard
          </Button>
        </HStack>

        {/* Footer */}
        <Text mt={10} fontSize="xs" color="gray.400">
          Rasoi Bills • We're cooking something special for you 🍽️
        </Text>
      </Box>
    </Flex>
  );
};

export default ComingSoon;
